import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { DISTRIBUTION_METRICS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  ruleId: string;
  communityId: string;
  data: FieldValues
}

const mutateUploadExcelMetricsByRuleId = async ({ ruleId, data, communityId }: mutateProps) => {
  return await axiosAuth.put(
    `${DISTRIBUTION_METRICS_API(communityId)}/${ruleId}/upload-excel`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useUploadExcelMetricsByRuleIdMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUploadExcelMetricsByRuleId,
    ...queryParams,
  });

export default useUploadExcelMetricsByRuleIdMutation;
